<template>
  <b-card style="padding:40px;">
    <h5>VIEW PRODUCT</h5>
    <hr />
    <b-container md="12">
      <center>
        <b-row>
          <b-col md="12">
            <b-img v-bind="mainProps" thumbnail fluid :src="this.form.img" />
          </b-col>
        </b-row>
      </center>
    </b-container>
    <br />
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-name`">Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Size</label>
          <b-form-input
            v-model="form.size"
            :id="`input-size`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Type</label>
          <b-form-input
            value="UHT"
            v-if="form.proCat == '1'"
            :id="`input-size`"
            :type="`text`"
            readonly
          ></b-form-input>
          <b-form-input
            value="Pasteurized"
            v-if="form.proCat == '2'"
            :id="`input-size`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Volume (ml)</label>
          <b-form-input
            v-model="form.volume"
            :id="`input-size`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack"
          >BACK</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        size: "",
        img: "",
        proCat: "",
        volume: ""
      },
      mainProps: { width: 400, height: 400, class: "m1" }
    };
  },
  created() {
    this.showProduct();
  },
  methods: {
    onClickBack() {
      this.$router.push({
        path: `product?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}`
      });
    },
    showProduct() {
      this.$store
        .dispatch("showProduct", {
          product_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.size = res.data.data.size;
            this.form.proCat = res.data.data.type;
            this.form.volume = res.data.data.milliliter;
            this.form.img =
              `${process.env.VUE_APP_BASE_URL}/` + res.data.data.path;
            // this.form.img = "https://azizazri.com/" + res.data.data.path;
          }
        });
    }
  }
};
</script>
<style lang="css" scoped></style>
